/**
 * 手机号隐私处理
 * @param str 手机号 "13122223333"
 * @returns 脱敏处理后的手机号 131****3333
 */
export default function telephonePrivacy(str) {
  if (!str) return '';
  var reg = /^(\d{3})\d{4}(\d{4})$/;
  return str.replace(reg, "$1****$2");
}